module.exports = __webpack_public_path__ + "img/herb-lavender-350x184.b34252b4.jpg";